/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { DeletePromoCodeFromEncounterErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const deleteEncountersPromocode = (encounterId: number) => {
  return api<void>({ url: `/api/encounters/${encounterId}/promocode`, method: 'DELETE' });
};

export const getDeleteEncountersPromocodeMutationOptions = <
  TError = DeletePromoCodeFromEncounterErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEncountersPromocode>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEncountersPromocode>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['deleteEncountersPromocode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEncountersPromocode>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return deleteEncountersPromocode(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEncountersPromocodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEncountersPromocode>>
>;

export type DeleteEncountersPromocodeMutationError = DeletePromoCodeFromEncounterErrorResponse;

export const useDeleteEncountersPromocode = <
  TError = DeletePromoCodeFromEncounterErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEncountersPromocode>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEncountersPromocode>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getDeleteEncountersPromocodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
